import React from 'react';
import { HtmlContent } from '@tribeplatform/react-components/HtmlContent';
import { Accordion as AccordionComponent } from '@tribeplatform/react-ui-kit/Accordion';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const AccordionBlock = ({ items, title }) => {
    if (!items) {
        return null;
    }
    return (React.createElement(Card, null,
        title && React.createElement(Card.Header, { title: title, size: "sm" }),
        React.createElement(Card.Content, null, items.map((item, index) => (React.createElement(AccordionComponent, { key: index, variant: "plus", iconAlign: "trailing", defaultOpen: item.defaultOpen, inset: "flush" },
            React.createElement(AccordionComponent.Button, null, item.title),
            React.createElement(AccordionComponent.Panel, null,
                React.createElement("article", null,
                    React.createElement(HtmlContent, { value: item.description, trustedDomains: ['*'] })))))))));
};
//# sourceMappingURL=Block.js.map